import type { i18n as I18n } from 'i18next';

/**
 * Mock test — целиком по-английски при любом языке интерфейса (решение владельца 20.10.2026, T5).
 *
 * 🔴 ЭТО НЕ ПОТЕРЯННЫЙ ПЕРЕВОД. Заставка, правила, таймер, кнопки, «Questions 1–10», результат,
 * балл, разбор («Listen from 0:43»), ошибки и состояния — всё внутри мока по-английски, как на
 * настоящем экзамене. Вход в мок (меню, главная, хаб тренажёров, карточка балла в профиле) —
 * на языке интерфейса: это уже не мок, а приложение.
 *
 * ⚠️ ПРАВИЛО НА ВЕСЬ ЭКРАН, А НЕ НА ПРЕФИКС КЛЮЧА. У блока записи голоса язык закреплён за
 * ключами (`lib/fixedLanguageKeys.ts`). Здесь так нельзя: карточки заданий (`TaskCard`), речевая
 * часть (`MockSpeaking`) и ключи `ieltsMock.*` общие со СПРИНТОМ, а спринт — тренажёр и говорит на
 * языке интерфейса. Правило `^ieltsMock\.` → en молча перевело бы на английский и спринт. Поэтому
 * экран мока целиком рендерится под отдельным экземпляром i18next с языком `en`
 * (`components/ielts/MockEnglish.tsx`): любой `useTranslation()` внутри — проигрыватель,
 * панель выделения, разговор с экзаменатором, разбор — получает английский, чей бы ключ он ни
 * спросил.
 *
 * ⚠️ ЧТО ПРОВАЙДЕР НЕ ЛОВИТ — ГЛОБАЛЬНЫЙ `i18n.t`. `humanizeError` берёт тексты из общего
 * экземпляра, поэтому в моке он зовётся с `MOCK_LANGUAGE`. Сторож обоих правил —
 * `lib/mockEnglish.test.ts`.
 *
 * Передумали — снять обёртку `MockEnglish` в `StudentIELTSMockPage` и второй аргумент у
 * `humanizeError` в ней же.
 */
export const MOCK_LANGUAGE = 'en';

const clones = new WeakMap<I18n, I18n>();

/**
 * Экземпляр i18next для мока: те же ресурсы и правки текстов с сервера (хранилище общее),
 * язык — английский. Общий экземпляр не меняется: `<html lang>`, язык меню и выбор
 * человека остаются прежними.
 */
export function mockI18n(base: I18n): I18n {
  if (base.language === MOCK_LANGUAGE) return base;
  let clone = clones.get(base);
  if (!clone) {
    clone = base.cloneInstance({ lng: MOCK_LANGUAGE });
    clones.set(base, clone);
  }
  return clone;
}
